import $ from 'jquery'

onDomLoad(function ($dom) {
  const accountEditForm = $dom[0].querySelector(
    "[data-behavior='account-edit-modal-form']"
  )

  if (!accountEditForm) return

  const accountDetailTemplateField = document.getElementById(
    'account_account_detail_template_id'
  )

  const originalAccountDetailTemplateValue = accountDetailTemplateField.value
  let accountDetailTemplateFieldChanged = false
  let userConfirmedUnReview = false

  accountDetailTemplateField.addEventListener('change', () => {
    accountDetailTemplateFieldChanged =
      originalAccountDetailTemplateValue !== accountDetailTemplateField.value
  })

  $(accountEditForm).on('ajax:before', () => {
    if (!accountDetailTemplateFieldChanged) return
    if (userConfirmedUnReview) return

    window.eventHub.$emit('confirmUnreviewTemplate', {
      callback: () => {
        userConfirmedUnReview = true
        // We use jQuery here because in Firefox this code runs before
        // the ajax:before event handler would finish and that creates all kind of bugs
        $(accountEditForm).submit()
      },
    })

    return false
  })
})
